import { create } from "lodash";

export default {
  l: {
    postingGroupFollowsClient: "No Client Posting Group set - the posting group follows the client",
    lockClientPostingGroup: "Lock Client Posting Group",
    add: "Add",
    addCashDesk: "Add Cash Desk",
    addChannel: "Add Channel",
    addCity: "Add City",
    addChannelClientCompositionMapping: "Add Channel Client Composition Mapping",
    addChannelHotelRateCodeMapping: "Add Channel Hotel Rate Code Mapping",
    addChannelHotelRoomTypeMapping: "Add Channel Hotel Room Type Mapping",
    addCountry: "Add Country",
    addCreditCardType: "Add Credit Card Type",
    addGeneralJournal: "Add General Journal",
    addJournalAccountType: "Add Journal Account Type",
    addJournalBatch: "Add Journal Batch",
    addJournalTemplate: "Add Journal Template",
    addRoomStatus: "Add Room Status",
    addRoomType: "Add Room Type",
    adminCode: "Admin Code",
    adminName: "Admin Name",
    adminNameAscii: "Admin Name ASCII",
    adminType: "Admin Type",
    amountAfterDiscount: "Amount After Discount",
    backOffice: "Back Office",
    bankAccount: "Bank Account",
    bankAccountId: "Bank Account ID",
    bookingSource: "Booking Source",
    cancel: "Cancel",
    cancelConfirmation: "Cancel Confirmation",
    capital: "Capital",
    cashDesk: "Cash Desk",
    channel: "Channel",
    channelAgencyCode: "Channel Agency Code",
    channelClientCompositionMapping: "Channel Client Composition Mapping",
    channelHotelRateCodeMapping: "Channel Hotel Rate Code Mapping",
    channelHotelRoomTypeMapping: "Channel Hotel Room Type Mapping",
    channelId: "Channel ID",
    channelManager: "Channel Manager",
    channelRateCode: "Channel Rate Code",
    channelRoomType: "Channel Room Type",
    channelRoomTypeCode: "Channel Room Type Code",
    city: "City",
    cityAlt: "City Alt",
    cityAscii: "City ASCII",
    code: "Code",
    country: "Country",
    countryId: "Country ID",
    credit: "Credit",
    creditCard: "Credit Card",
    creditCardType: "Credit Card Type",
    customer: "Customer",
    customerNo: "Customer No.",
    customerLedger: "Customer Ledger",
    dashboard: "Dashboard",
    defaultBookingSource: "Default Booking Source",
    defaultMarketSegment: "Default Market Segment",
    delete: "Delete",
    deleteConfirmation: "Delete Confirmation",
    density: "Density",
    description: "Description",
    documentNo: "Document No.",
    documentType: "Document Type",
    edit: "Edit",
    editCashDesk: "Edit Cash Desk",
    editChannel: "Edit Channel",
    editCity: "Edit City",
    editChannelClientCompositionMapping: "Edit Channel Client Composition Mapping",
    editChannelHotelRateCodeMapping: "Edit Channel Hotel Rate Code Mapping",
    editChannelHotelRoomTypeMapping: "Edit Channel Hotel Room Type Mapping",
    editCountry: "Edit Country",
    editCreditCardType: "Edit Credit Card Type",
    editGeneralJournal: "Edit General Journal",
    editJournalAccountType: "Edit Journal Account Type",
    editJournalBatch: "Edit Journal Batch",
    editJournalTemplate: "Edit Journal Template",
    editRoomStatus: "Edit Room Status",
    editRoomType: "Edit Room Type",
    entryNo: "Entry No.",
    failed: "Failed",
    frontOffice: "Front Office",
    generalJournal: "General Journal",
    hotelAgency: "Hotel Agency",
    hotelAgencyGroup: "Hotel Agency Group",
    hotelClient: "Hotel Client",
    hotelRate: "Hotel Rate",
    hotelRoomType: "Hotel Room Type",
    iso2Code: "ISO2 Code",
    journalAccountNo: "Journal Account No.",
    journalAccountType: "Journal Account Type",
    journalBatch: "Journal Batch",
    journalTemplate: "Journal Template",
    latitude: "Latitude",
    lineNo: "Line No.",
    longitude: "Longitude",
    mandatory: "Mandatory",
    marketSegment: "Market Segment",
    masterData: "Master Data",
    name: "Name",
    new: "New",
    no: "No",
    numericCode: "Numeric Code",
    officialStateName: "Official State Name",
    originalAmount: "Original Amount",
    population: "Population",
    populationProper: "Population Proper",
    postingDate: "Posting Date",
    rate: "Rate",
    ranking: "Ranking",
    roomStatus: "Room Status",
    roomType: "Room Type",
    sameName: "Same Name",
    save: "Save",
    simpleMapsCityId: "SimpleMapsCity ID",
    successful: "Successful",
    timezone: "Timezone",
    yes: "Yes",
    variance: "Variance",
    mealDate: "Meal Date",
    cannotModifySelectedData: "Cannot Modify Selected Data",
    betaTesting: "Beta Testing",
    startOperatingHour: "Start Operating Hour",
    endOperatingHour: "End Operating Hour",
    foodAndBeverage: "Food And Beverage",
    allDepartments: "All Departments",
    selectAllDepartments: "Select All Departments",
    changeCollectionType: "Change Collection Type",
    addItem: "Add {item}",
    currentItem: "Current {item}",
    changeItem: "Change {item}",
    salesByTableLabelReport: "Sales By Table Label Report",
    label: "Label",
    edcMachineIntegration: "EDC Machine Integration",
    enableEdcMachine: "Enable EDC Machine",
    edcMode: "EDC Mode",
    edcModeAlways: "Always use EDC",
    edcModePrompt: "Prompt cashier to choose",
    edcAgentUrl: "Sentec Agent URL",
    edcAgentUrlPlaceholder: "Leave empty to use pos.agent URL",
    edcAgentUrlHint: "Falls back to pos.agent URL if not set",
    edcAgentToken: "Sentec Agent Token",
    edcAgentTokenPlaceholder: "Leave empty to use pos.agent token",
    edcAgentTokenHint: "Overrides the pos.agent token when set",
    edcVendor: "EDC Vendor",
    edcComPort: "COM Port",
    edcComPortPlaceholder: "e.g. COM3",
    edcTestConnection: "Test Connection",
    edcConnected: "Connected",
    edcFailed: "Failed",
    edcEnterAgentUrlFirst: "Please enter the Sentec Agent URL first.",
    edcPayment: "EDC Payment",
    edcInvoiceAmountRemaining: "Invoice amount remaining",
    edcUserPayment: "User payment",
    edcTerminalWillReceive: "Terminal will receive: {amount} ({currency} minor units)",
    edcChange: "Change",
    edcRemainingPayment: "Remaining payment",
    edcPressPayToInitiate: "Press Pay to initiate EDC transaction",
    edcWaitingForCard: "Waiting for card tap / insert...",
    edcSecondsRemaining: "{seconds}s remaining",
    edcCancel: "Cancel",
    edcTransactionApproved: "Transaction Approved",
    edcTransactionFailed: "Transaction Failed",
    edcRetry: "Retry",
    edcPayViaEdc: "Pay via EDC",
    edcConfirm: "Confirm",
    edcCard: "Card",
    edcAuthCode: "Auth Code",
    edcTraceNumber: "Trace #",
    edcTerminal: "Terminal",
    edcTransactionDeclined: "Transaction declined",
    edcConnectionFailed: "Failed to connect to EDC terminal",
    edcTotalPaymentAlreadyEqual: "Total payment already equal to invoice amount.",
  },
  m: {
    dimensionValueNotInDimension: "That value belongs to a different dimension. Pick a value of the selected dimension.",
    dimensionSetupOwnerChanged: "The selected record changed. The dimension was not saved — reopen the setup and try again.",
    saveFirstBeforeDimensionSetup: "Save this record first, then configure its dimensions.",
    fieldIsRequired: "This field is required",
    confirmCancel: "Are you sure you want to cancel {f}? This process cannot be undone.",
    confirmDelete: "Are you sure you want to delete {f}? This process cannot be undone.",
    err: {
      betLen: "{f} must be between {v1} and {v2} characters",
      cantXWhileOffline: "Can't {x} while offline",
      ge: "{f} must be more than or equal to {v}",
      gt: "{f} must be more than {v}",
      le: "{f} must be less than or equal to {v}",
      lt: "{f} must be less than {v}",
      maxLen: "{f} must be a maximum of {v} characters",
      maxVal: "The maximum value of {f} is {v}{x}",
      minLen: "{f} must be a minimum of {v} characters",
      minMaxVal: "Value of {f} must be from {v1}{x} to {v2}{x}",
      minVal: "The minimum value of {f} is {v}{x}",
      number: "{f} must be a number, either positive or negative",
      numeric: "{f} must consist of only numeric characters",
      req: "{f} is required",
      duplicate: "{f} {v} already exist",
    },
    confirmLogout: "Are you sure want to logout?",
    confirmFlushSiteData: "Are you sure you want to clear site data? This will log you out and refresh the page.",
    successFlushSiteData: "Site data cleared. You will be signed out, and the page will now refresh.",
    invalidPhoneNumber: "Phone number is not valid, only numbers and + allowed",
    invalidDateOfBirth: "The date of birth is invalid. Please use the format YYYY-MM-DD.",
  },
  common: {
    add: "Add",
    cancel: "Cancel",
    description: "Description",
    delete: "Delete",
    title: "Title",
    save: "Save",
    faq: "FAQ",
    contact: "Contact Us",
    tos: "Terms of Service",
    policy: "Privacy Policy",
    articleFlavour: "Article Flavour",
    articleGroupName: "Article Group",
    showFlavour: "Show Flavour",
    hide: "Hide",
    created: "Created",
    updated: "Updated",
    deleted: "Deleted"
  },
  agent: {
    availableDownloads: "Available Downloads",
    checkVersion: "Check Version",
    sentecAgentConfigSettings: "Sentec Agent Configuration Settings",
    sentecAgentAccounts: "Sentec Agent Accounts (V2)",
    sentecAgentAccountsDesc: "Sentec Agent accounts for the use of WebSocket communication protocol",
    pleaseCheckDeviceConfigurationSentecAgent: "Please check if the device, configuration, and Sentec Agent Service are properly set up and running",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "Please check if the device and configuration are set up correctly. If everything is correct, ensure that the PMS Interface Server is running",
    viewDownloads: "View Downloads",
  },
  board: {
    titlePlaceholder: "Enter a title for this card",
    deleteDescription: "Are you sure you want to delete this card?",
    editCard: "Edit Card",
    deleteCard: "Delete Card",
    state: {
      TODO: "TO DO",
      INPROGRESS: "INPROGRESS",
      TESTING: "TESTING",
      DONE: "DONE"
    }
  },
  chat: {
    online: "Users Online ({count})",
    addChannel: "Add Channel",
    channel: "Channel | Channels",
    message: "Message"
  },
  email: {
    compose: "Compose Email",
    send: "Send",
    subject: "Subject",
    labels: "Labels",
    emptyList: "Empty email list",
    inbox: "Inbox",
    sent: "Sent",
    drafts: "Drafts",
    starred: "Starred",
    trash: "Trash",
    work: "Work",
    invoice: "Invoice",
    notValid: "Email not valid"
  },
  todo: {
    addTask: "Add Task",
    tasks: "Tasks",
    completed: "Completed",
    labels: "Labels"
  },
  dashboard: {
    activity: "Activity",
    weeklySales: "Weekly Sales",
    sales: "Sales",
    recentOrders: "Recent Orders",
    sources: "Traffic Sources",
    lastweek: "vs last week",
    orders: "Orders",
    customers: "Customers",
    tickets: "Support Tickets",
    viewReport: "View Report",
    totalPaidOrders: "Total Paid Orders",
    totalAmount: "Total Amount",
    totalTaxes: "Total Taxes",
    grandTotal: "Grand Total",
    totalQty: "Total Qty",
    totalGuests: "Total Guests",
    totalQuickOrders: "Total Quick Orders",
    foodTotalAmount: "Food Total Amount",
    foodTotalQty: "Food Total Qty",
    beverageTotalAmount: "Beverage Total Amount",
    beverageTotalQty: "Beverage Total Qty",
    othersTotalAmount: "Others Total Amount",
    othersTotalQty: "Others Total Qty",
    tobaccoTotalAmount: "Tobacco Total Amount",
    tobaccoTotalQty: "Tobacco Total Qty",
    totalCovers: "Total Covers (Guests Served)",
    averageSpendPerGuest: "Average Spend Per Guest",
    averageTransactionValue: "Average Transaction Value",
    assumedTableTurnTime: "Assumed Table Turn Time",
    averageTableTurnTime: "Average Table Turn Time",
    seatingCapacity: "Seating Capacity",
    totalItemsSold: "Total Items Sold",
    totalTransactions: "Total Transactions",
    summaryMetrics: "Summary Metrics",
    potentialCoversPerMealtime: "Potential Covers per Mealtime",
    serviceCharge: "Service Charge ({percent}% of Revenue)",
    vatRevenue: "VAT ({percent}% of Revenue)",
    netSales: "Net Sales (Excl. Tax & Service)",
    dateRangeTo: "Date Range: {s} to {e}",
    topThreeItemsSold: "Top Three Items Sold",
    topDiscounts: "Top Discounts",
    outletHours: "Outlet Hours:",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    allDayDining: "All Day Dining",
    potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} covers ({seating_capacity} seats x {potential_turns_per_mealtime} turns)",
    occupancyRateDesc: "{occupancy_rate} % ({total_covers} guest / {total_seats} seats x {potential_turns_per_mealtime} potential turns over {days_config} days)",
    mealTime: "Meal Time",
    allRevenueExcludingComplimentary: "All revenue, excluding complimentary items.",
    complimentaryExcluded: "Complimentary Excluded",
    allRevenueAllDayIncludeComplimentary: "All revenue is from all-day dining and includes complimentary services.",
    totalItemIncludingComplimentaryItems: "Total item including complimentary items",
    totalTransactionsIncludingComplimentary: "Total transactions including complimentary",
    totalBaseAmountExcludingComplimentaryItems: "Total base amount excluding complimentary items",
    totalCoversNumberOfGuestIncludingComplimentary: "Total covers (number of guest) including complimentary",
    averageSpendPerGuestExcludingComplimentaryItemsOrServices: "Average spend per guest, excluding complimentary items or services.",
    averageTransactionValueExcludingComplimentaryItemsOrServices: "Average transaction value, excluding complimentary items or services.",
    averageTableTurnoverTimeComplimentaryExcluded: "Average table turnover time, complimentary excluded",
    percentageOfAvailableSeatCapacityUsedByGuests: "The percentage of available seat capacity that was actually used by guests",
    totalOrdersIncludeComplimentary: "Total orders include complimentary.",
    totalPaidOrdersIncludeComplimentary: "Total paid orders include complimentary.",
    clickForDetailsBreakdown: "Click for details / breakdown",
    totalNumberOfSeatsAvailableForGuests: "The total number of seats available for guests",
    percentageOfAvailableSeatCapacityActuallyUsedByGuests: "The percentage of available seat capacity that was actually used by guests",
    totalServiceChargeExcludingComplimentaryItems: "Total service Charge, excluding complimentary items",
    totalVatRevenueExcludingComplimentaryItems: "Total VAT revenue, excluding complimentary items",
    totalNetSalesExcludingComplimentaryItems: "Total Net Sales, excluding complimentary items",
    totalTaxesExcludingComplimentaryItems: "Total Taxes, excluding complimentary items",
    totalNetSalesIncludingComplimentaryItems: "Total Net Sales, including complimentary items",
    totalAmountExcludingComplimentaryItems: "Total Amount, excluding complimentary items",
    applyFilter: "Apply Filter",
  },
  usermenu: {
    profile: "Profile",
    signin: "Sign In",
    dashboard: "Dashboard",
    signout: "Sign Out"
  },
  error: {
    notfound: "Page Not Found",
    other: "An Error Occurred",
    failedUpdateOrder: "Failed to update order",
    noPermission: "You don't have permission to perform this action"
  },
  check: {
    title: "Set New Password",
    backtosign: "Back to Sign In",
    newpassword: "New Password",
    button: "Set new password and Sign in",
    error: "The action link is invalid",
    verifylink: "Verifying link...",
    verifyemail: "Verifying email address...",
    emailverified: "Email verified! Redirecting..."
  },
  forgot: {
    title: "Forgot Password?",
    subtitle: "Enter your account email address and we will send you a link to reset your password.",
    email: "Email",
    button: "Request Password Reset",
    backtosign: "Back to Sign In"
  },
  login: {
    title: "Sign In",
    email: "Email",
    password: "Password",
    button: "Sign In",
    orsign: "Or sign in with",
    forgot: "Forgot password?",
    noaccount: "Don't have an account?",
    create: "Create one here",
    error: "The email / password combination is invalid"
  },
  register: {
    title: "Create Account",
    name: "Full name",
    email: "Email",
    password: "Password",
    passwordRetype: "Retype Password",
    button: "Create Account",
    orsign: "Or sign up with",
    agree: "By signing up, you agree to the",
    account: "Already have an account?",
    signin: "Sign In"
  },
  order: {
    cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "Can't correct payment because tax interface status is valid",
    cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "Can't delete payment because tax interface status is valid",
    deleteSentOrder: "Delete Sent Order",
    closeOrder: "Close Order",
    closeOrderConfirmation: "Are you sure you want to close this order?"
  },
  parameter: {
    stickyLabelPrintSettings: "Sticky Label Print Settings",
    maxPreviewBillPrintCount: "Maximum Preview Bill Print Count",
    maxPreviewBillPrintCountReached: "Printing Limit Exceeded: You've reached the maximum allowed preview bill prints.",
    maxPreviewBillPrintCountLimit0: "Enter '0' for no limit",
    numberSeriesAndVATExemption: "Number, Series & VAT Exemption",
    billPrintSettings: "Bill Print Settings",
    wrapText: "Wrap Text",
    defaultPrinter: "Default Printer",
    fontSize: "Font Size (in point)",
    topMargin: "Top Margin (in point)",
    leftMargin: "Left Margin (in point)",
    rightMargin: "Right Margin (in point)",
    bottomMargin: "Bottom Margin (in point)",
    lineOffset: "Line Offset (in point)",
    hideHotelNameInBillPrint: "Hide hotel name in bill print",
    vatRegNo: "VAT Reg No",
    minNo: "Min No",
    snNo: "SN No",
    checkNoSeries: "Check No Series",
    receiptNoSeries: "Receipt No Series",
    permitNo: "Permit No (STN S/N)",
    accreditedNo: "Accredited No",
    isEnableExemptVAT: "Is Enable Exempt VAT",
    allowDeleteSentItems: "Allow delete sent items",
    askPinOnDeleteOrVoid: "Ask for PIN when deleting sent orders, or void",
    showBraceletAsCollectionType: "Show Bracelet as Collection Type",
    headerText1: "Header Text 1",
    headerText2: "Header Text 2",
    footerText1: "Footer Text 1",
    footerText2: "Footer Text 2",
    layoutCSalesInvoiceStatement: "Layout C Sales Invoice Statement",
    hideTaxInLayoutCommonD: "Hide VAT and Service Charge",
    hideTaxInLayoutCommonDHint: "For Layout Common D (Cambodian) only",
    billPrintCombineTaxLines: "Combine Tax and Additional Tax into one line",
    billPrintCombineTaxLinesHint: "Prints every tax line except Service Charge as one line on the bill",
    salesCreditMemoSeries: "Sales Credit Memo Series",
    isCardNumberNotMandatory: "Card number not mandatory",
    isCardNameNotMandatory: "Card name not mandatory",
    isCardTraceNoNotMandatory: "Trace number not mandatory",
    isDeleteSentOrderReasonNotMandatory: "Delete sent order reason not mandatory",
    isCancelOrderReasonNotMandatory: "Cancel order reason not mandatory",
    isPrintCancelOrderDoc: "Print cancel order document on delete sent order",
    splitBillByItem: "Allow Split Bill by Item",
    enableTips: "Enable Tips",
    enableTipsHint: "Capture customer tips (Cash/Card) on the Payment dialog",
    isPrintBillOnQuickOrder: "Print bill",
    isSendFoodOnQuickOrder: "Send order food product type",
    isSendBeverageOnQuickOrder: "Send order beverage product type",
    isSendOthersOnQuickOrder: "Send order others product type",
    isSendTobaccoOnQuickOrder: "Send order tobacco product type",
    showGuestSignatureFieldInPreviewBill: "Show Guest Signature Field in Preview Bill",
    showRoomNoFieldInPreviewBill: "Show Room No Field in Preview Bill",
    billShowRoomName: "Show Room Name Instead of Room Number in Bill",
    showTipFieldInPreviewBill: "Show TIP Field in Preview Bill",
    font: "Font",
    textBold: "Text Bold",
    sendOrderPrintSettings: "Send Order Print Settings",
    amountOfBillToPrintOnProcessingPayment: "Amount of Bill Copy on Processing Payment",
    isMultiplePaymentGroupedByType: "Multiple Payment Grouped by Payment Type",
    billPrintShowGuestPaymentAmountOnCash: "Show Guest Payment Amount on Cash Payment",
    showManualOrNumber: "Show Manual OR Number (Cash & Credit)",
    billPrintLogoWidth: "Logo Width (in point)",
    showGuestNameInSendOrder: "Show Guest Name in Send Order",
    allowZeroCover: "Allow Zero Cover",
    serialNo: "Serial No",
    stnSn: "STN S/N",
    defaultItem: "Default {item}",
    showPackageOrderDetailPrice: "Show Package Order Detail Price",
    allowPackageMemberDiscount: "Allow Discount For Package Members",
    packageGroupName: "Package Group Name",
    useMenuTags: "Use Menu Tags",
    birZCounterSeries: "BIR Z Counter Series",
  },
  printer: {
    identifyThisDeviceAsX: "Identify this device as {x}",
    unassignThisDeviceFromX: "Unassign this device from {x}",
    overrideAndAssignThisDeviceAsX: "Override assigned device and set this device as {x}",
    thisDeviceIsX: "This device is {x}",
    testPrint: "Test Print",
    testPrintContent: "Test Content",
    testPrintSettings: "Print Settings",
    sendTestPrint: "Send Test Print",
    resetToDefault: "Reset to Default",
    testPrintSent: "Test print sent",
    testPrintFailed: "Test print failed",
    testPrintNoAgent: "No SentecAgent host or printer URL is configured for this printer"
  },
  printerType: {
    printerName: "Printer Name",
    paperWidth: "Paper Width (in mm)",
    paperHeight: "Paper Height (in mm)",
    isSupportExternal: "Is Support External"
  },
  utility: {
    maintenance: "In Maintenance"
  },
  outlet: {
    taxDeclaration: "Tax Declaration",
    vatExemptionNote: "VAT Exemption Note",
    applyDiscountWithVATExemptionToOutletWithDisabledExemptVAT: "Can't apply discount with VAT exemption as the 'Enable Exempt VAT' setting is currently set to false.",
    exemptUnexemptVAT: "Exempt / Unexempt VAT",
    exemptVAT: "Exempt VAT",
    unExemptVAT: "Unexempt VAT",
    noPriceSetup: "No Price Setup",
    noPriceAssignedToThisArticleOnCurrentWorkingDateContinue: "No price assigned to this article on current working date. Continue?",
    cantAddArticleBecauseNoPriceAssignedToThisArticleOnCurrentWorkingDateAndAllowManualPriceIsSetToFalse: "Can't add article because no price is assigned to this article on current working date and manual price entry is disabled.",
    cantModifySelectedTotalDiscount: "Can't modify selected total discount.",
    cantSelectSavedOrSentItemIfInGarnishMode: "You can't select an item that has already been sent or saved when garnish mode is enabled.",
    cantSetCourseStageOfChildWhileParentNotSelected: "Can't set course stage of child item while its parent is not selected.",
    processingOrder: "Processing Order",
    creatingQuickOrder: "Creating Quick Order",
    creatingOrder: "Creating Order",
    createOrder: "Create Order",
    createOrderForX: "Create Order for table reservation with guest name {x}",
    itemAlreadySaved: "Item already saved",
    itemAlreadySent: "Item already sent",
    noItemToPay: "No item to pay",
    failedToPrintTo: "Failed to Print to {x}",
    successToPrintTo: "Success to Print to {x}",
    captainOrderIminNotThisDevice: "{x} is a built-in printer on another device, so the captain order could not be printed there.",
    captainOrderM7NeedsAgent: "{x} is an on-device print server with no agent assigned. Assign an agent to it so captain orders can reach it.",
    captainOrderIminNotConnected: "Could not connect to this device's built-in printer ({x}).",
    captainOrderIminStatusError: "This device's built-in printer ({x}) reported status {status}, so the captain order was not printed.",
    retry: "Retry",
    invalidPaymentMethod: "Invalid payment method",
    customerOrderX: "Customer Order {x}",
    pleaseSelectItemsToSend: "Please select item(s) to send",
    itemsRemovedFromTheList: "Item(s) removed from the list",
    missingInvoiceSeries: "Missing invoice series",
    cantChooseXForSplitPayment: "Can't choose {x} for split payment",
    amountToPay: "Amount to Pay",
    amountToPayCantBeGreaterThanRemainingPayment: "Amount to Pay can't be greater than Remaining Payment",
    fireX: "Fire {x}",
    hold: "Hold",
    setStage: "Set Stage",
    selectOutlet: "Select Outlet",
    xPax: "{x} PAX",
    orderIDIsNotGenerated: "Order ID is not generated yet.",
    cantDeleteChildOfSentItem: "Can't delete child of sent items without deleting its parent.",
    cantDeleteSentOrderWhileOffline: "Can't delete sent order while offline",
    cancelOrderDocBillPrinterNotConfigured: "Cancel order document was not printed: no default bill printer is configured for this outlet.",
    labelPrinterNotConfigured: "Label printer is not configured for this outlet. Set a label printer in POS Parameter settings.",
    orderType: "Order Type",
    dineIn: "Dine-in",
    pickup: "Pickup",
    labelPrinter: "Label Printer",
    alsoPrintStickyLabel: "Also print sticky labels",
    labelPrinterId: "Label Printer ID",
    printLabel: "Print Label",
    noItemSelectedToPrintLabel: "No items selected to print labels.",
    labelOnlyForSentItems: "Labels can only be printed for sent items.",
    cantPrintLabelClosedOrder: "Cannot print labels for a closed or canceled order.",
    cancelOrderDocOutletMissing: "Cannot print: selected items are missing outlet information.",
    cancelOrderDocSingleOutletOnly: "Cannot print across multiple outlets — please select items from a single outlet.",
    cancelOrderDocParameterNotFound: "Cannot print: outlet POS parameter not found.",
    cancelOrderDocNotEnabledForOutlet: "Cancel order document printing is not enabled for this outlet.",
    cantChangeQtySentItem: "Can't change the quantity because at least one selected item was already sent.",
    flavourCantAssignToChild: "Flavour can't be assigned to child item.",
    flavourItemAlreadySent: "Item already sent.",
    flavourNothingSelected: "No item selected to assign flavour to.",
    flavourOnlySingleParent: "Flavour can only be assigned to one parent article.",
    qtyChangeNoSelection: "No article or garnish selected to apply quantity change.",
    qtyChangeMultipleSelection: "There are more than one articles and/or garnishes selected to apply quantity change.",
    cantSendZeroPriceItems: "Items with a total price of 0 or less can't be sent.",
    quantityLimitExceeded: "{name}: Max Qty sold per day ({limit}) exceeded. {remaining} remaining, please review the qty.",
    itemsAlreadySent: "One or more selected items were already sent.",
    noPrinterOrScreenConfigured: "No printer or screen is configured to send this order.",
    failedToSendToPrinterOrScreen: "Failed to send the order to the printer or kitchen screen. The order will still be saved.",
    parentNotSelectedForSend: "Can't send a child item while its parent is not selected.",
    cantSendOrderWhileOffline: "Can't send order while offline.",
    packageMemberDiscountDisabled: "Discount on package members is disabled in POS parameter.",
    garnishNotApplicableForPackage: "Garnishes are not applicable for package items.",
    ignoredSetStageForPackage: "Set stage is not applicable for package items.",
    changePriceNotAllowedForPackage: "Change price is not allowed for package items.",
    discountTotal: "Discount Total",
    noItem: "No Item",
    allSavedItemsAlreadyHaveDiscountApplied: "All saved items already have discount applied.",
    cantHaveMultipleDiscountTotal: "Can't have multiple discount totals.",
    maxDiscountToApply: "Max Discount to Apply",
    cashReceived: "Cash Received",
    cashChange: "Change",
    outletType: "Outlet Type",
    roomService: "Room Service",
    noItemSelectedToAssignVAT: "No item selected to assign exempt / unexempt VAT to",
    exemptVATCantBeAppliedToFlavour: "Exempt / unexempt VAT can't be applied to flavour",
    unexemptVATForSelectedItem: "This will unexempt VAT for the selected item. Are you sure?",
    unexemptVATForXItems: "This will unexempt VAT for {x} selected items. Are you sure?",
    mixedVATSelection: "You selected {x} item(s) without VAT exemption and {y} item(s) that are already exempted. Choose how you want to proceed.",
    discountAppliesToNonExemptOnly: "The discount will be applied to the {x} item(s) without VAT exemption only — the {y} already-exempted item(s) will be left unchanged.",
    discountSkippedLines: "These items will not be discounted and are left unchanged, because a manual discount is not allowed on them: {items}",
    discountExemptProofsDiffer: "The selected items carry different VAT-exemption evidence (a different PWD ID, Senior Citizen ID or note). Discounting them together would apply one item's evidence to all of them, so discount them one at a time instead.",
  },
  discount: {
    amountIsBaseTaxAdded: "The amount entered is a base amount. Tax and service charge are added on top where applicable, so the amount deducted from the total may be higher than the amount entered.",
    isExemptVAT: "Is Exempt VAT",
    exemptionProofType: "VAT Exemption Proof",
    useExemptionNote: "Use Note",
    usePwdId: "Use PWD ID",
    useSeniorCitizenId: "Use Senior Citizen ID",
    pwdId: "PWD ID",
    seniorCitizenId: "Senior Citizen ID",
    pwdName: "PWD Name",
    seniorCitizenName: "Senior Citizen Name"
  },
  price: {
    currentBasePrice: "Current Base Price",
    currentPPVATSetupPrice: "Current Price Period VAT Setup Price",
    currentAGOVATSetupPrice: "Current Article Group Outlet VAT Setup Price",
    vatPriceSetupCode: "VAT Price Setup Code",
    vatAGOSetupCode: "VAT Article Group Setup Code",
    currentExemptedVATSetupPrice: "Current Exempted VAT Setup Price",
    vatExemptedSetupCode: "VAT Exempted Setup Code",
    articleArticleGroupId: "Article Article Group ID",
    changeWillBeAppliedToNPricePeriods: "Changes will be applied to {n} price periods",
    batchUpdateWarningNote: "To update price data, check 'Update Price' and enter a new value. Fill in other fields as needed to apply updates. Leave any field blank to keep its current value.",
    showOnFbMenu: "Show on FB Menu",
    batchShowOnFbMenu: "FB Menu Visibility",
    bulkShowOnFbMenu: "Show on QR Menu",
    bulkHideFromFbMenu: "Hide from QR Menu",
    subRecipe: "Sub Recipe",
    addSubRecipe: "Add Sub Recipe"
  },
  generalSetup: {
    printDeletedSentOrder: "Print deleted sent order",
    showNFCIconInToolbar: "Show NFC Icon in Toolbar",
    showQuickOrderIconInToolbar: "Show Quick Order Icon In Toolbar",
    showQuickOrderInMenu: "Show Quick Order In Menu",
    hideTableNumberInTableList: "Hide table number in table list",
    showValidityAcknowledgmentCertificateStatement: "Show Certificate Acknowledgment Validity Statement",
    billCopyWording: "Bill 'Copy' wording",
    customerTaxIdentifierText: "Customer Tax Identifier Text (default 'Customer PIN')",
    sendOrderToScreens: "Send Order to Screens",
    systemInfo: "System Information",
    systemName: "System Name",
    systemVatRegTin: "System VAT REG TIN",
    vatRegTin: "VAT REG TIN",
    systemAccrNo: "System Accr. No",
    accrNo: "Accr. No",
    dateIssued: "Date Issued",
    validUntil: "Valid Until",
    systemAccrIssuedDate: "System Accr. Issued Date",
    systemAccrValidUntil: "System Accr. Valid Until",
    systemPtuNo: "System PTU No",
    ptuNo: "PTU No",
    systemAddress: "System Address",
    systemPtuIssuedDate: "System PTU Issued Date",
  },
  faq: {
    call: "Have other questions? Please reach out "
  },
  ecommerce: {
    products: "Products",
    filters: "Filters",
    collections: "Collections",
    priceRange: "Price Range",
    customerReviews: "Customer Reviews",
    up: "and up",
    brand: "Brand",
    search: "Search for product",
    results: "Results ( {0} of {1} )",
    orders: "Orders",
    shipping: "Shipping",
    freeShipping: "Free Shipping",
    inStock: "In Stock",
    quantity: "Quantity",
    addToCart: "Add To Cart",
    buyNow: "Buy Now",
    price: "Price",
    about: "About this item",
    description: "Description",
    reviews: "Reviews",
    details: "Product Details",
    cart: "Cart",
    summary: "Order Summary",
    total: "Total",
    discount: "Discount",
    subtotal: "Subtotal",
    continue: "Continue Shopping",
    checkout: "Checkout"
  },
  intercompanyMapping: {
    sourceHotel: "Source Hotel",
    targetHotel: "Target Hotel",
    sourceArticle: "Source Article",
    targetArticle: "Target Article",
    sourceArticleGroup: "Source Article Group",
    targetArticleGroup: "Target Article Group",
    asSource: "As Source",
    asTarget: "As Target",
    mapping: "Mapping",
    intercompanyArticleMapping: "Intercompany Article Mapping",
    intercompanyArticleGroupMapping: "Intercompany Article Group Mapping",
    checkTargetOutletStatus: "Intercompany Mapping: Check Target Outlet Status",
    createIntercompanyMappingEntries: "Intercompany Mapping: Create Intercompany Mapping Entries",
    productTypesToTransfer: "Product Types to Transfer",
    defaultPayment: "Target Default Payment",
    defaultComplimentaryPayment: "Target Default Complimentary Payment",
    defaultCollectionIdentification: "Target Default Collection Identification",
    defaultOutlet: "Target Default Outlet",
    defaultTable: "Target Default Table",
    sourceOutlet: "Source Outlet",
    sourceArticleProductType: "Source Article Product Type",
    prefix: "Target Prefix",
    checkSourceOutletStatus: "Intercompany Mapping: Check Source Outlet Status",
  },
  menu: {
    rateManagement: "Rate Management",
    reservation: "Reservation",
    reservationNew: "New",
    reservationList: "List",
    frontOffice: "Front Office",
    generalSettings: "General Settings",
    guestTitle: "Guest Title",
    guestDocumentType: "Guest Document Type",
    manageHotel: "Hotel",
    hotel: "Hotel",
    hotelList: "List",
    hotelCategory: "Hotel Category",
    hotelChain: "Hotel Chain",
    marketSegment: "Market Segment",
    rooms: "Rooms",
    currency: "Currency",
    search: "Search (press \"ctrl + /\" to focus)",
    dashboard: "Dashboard",
    logout: "Logout",
    flushSiteData: "Clear Site Data",
    profile: "Profile",
    blank: "Blank Page",
    pages: "Pages",
    others: "Others",
    email: "Email",
    chat: "Chat",
    todo: "Todo",
    board: "Task Board",
    users: "Users",
    usersList: "List",
    usersEdit: "Edit",
    ecommerce: "Ecommerce",
    ecommerceList: "Products",
    ecommerceProductDetails: "Product Details",
    ecommerceOrders: "Orders",
    ecommerceCart: "Cart",
    auth: "Auth Pages",
    authLogin: "Signin / Login",
    authRegister: "Signup / Register",
    authVerify: "Verify Email",
    authForgot: "Forgot Password",
    authReset: "Reset Password",
    errorPages: "Error Pages",
    errorNotFound: "Not Found / 404",
    errorUnexpected: "Unexpected / 500",
    utilityPages: "Utility Pages",
    utilityMaintenance: "Maintenance",
    utilitySoon: "Coming Soon",
    utilityHelp: "FAQs / Help",
    levels: "Menu Levels",
    disabled: "Menu Disabled",
    docs: "Documentation",
    feedback: "Feedback",
    support: "Support",
    tables: "Tables",
    orderHistories: "Order Histories",
    all: "All",
    closed: "Closed",
    open: "Open",
    deletedSentOrders: "Deleted Sent Orders",
    deletedOrderPayments: "Deleted Order Payments",
    transferOrderHistory: "Transfer Order History",
    closedDays: "Closed Days",
    screens: "Screens",
    masterData: "Master Data",
    outlet: "Outlet",
    generalSetup: "General Setup",
    parameter: "Parameter",
    table: "Table",
    articleProductType: "Article Product Type",
    article: "Article",
    articleGroup: "Article Group",
    articleGroupSetup: "Article Group Setup",
    articleGroupOutletSetup: "Article Group Outlet Setup",
    articleFlavourGroup: "Article Flavour Group",
    articleFlavour: "Article Flavour",
    articleFlavourGroupArticleGroupSetup: "Article Flavour Group Article Group Setup",
    collectionCategory: "Collection Category",
    collectionType: "Collection Type",
    collectionIdentificationGroup: "Collection Identification Group",
    collectionIdentification: "Collection Identification",
    collectionTypeOutletSetup: "Collection Type Outlet Setup",
    price: "Price",
    discount: "Discount",
    printer: "Printer",
    screen: "Screen",
    agent: "Agent",
    banquet: "Banquet",
    banquetGroupList: "Banquet Group List",
    banquetReservationList: "Banquet Reservation List",
    banquetReservationCalendar: "Banquet Reservation Calendar",
    reports: "Reports",
    masterAccount: "Master Account",
    incomeAudit: "Income Audit",
    outletStatus: "Outlet Status",
    manageNfcBracelet: "Manage NFC Bracelet",
    taxInterfaceIntegrationLog: "Tax Interface Integration Log",
    workingDay: "Working Day",
    index: "Index",
    printerType: "Printer Type",
    quickOrder: "Quick Order",
    mealTimeSetup: "Meal Time Setup",
    tableReservation: "Table Reservation",
    breakfastRegistration: "Breakfast Registration",
    mealRegistration: "Meal Registration",
    roomBreakfastRegistration: "Room Breakfast Registration",
    roomLunchRegistration: "Room Lunch Registration",
    roomDinnerRegistration: "Room Dinner Registration",
    banquetLunchRegistration: "Banquet Lunch Registration",
    banquetDinnerRegistration: "Banquet Dinner Registration",
    itemLoan: "Item Loan",
    maintenanceRequest: "Maintenance Request",
    courseStage: "Course Stage",
    waiter: "Waiter",
    intercompanyMapping: "Intercompany Mapping",
    fbMenuOrderRequest: "Digital Menu Order Request",
    fbMenuConfiguration: "FB Menu Configuration",
    guestProfiles: "Guest Profiles",
    tableLabelManagement: "Table Label Management",
    package: "Package",
    captainOrder: "Captain Order",
    workingDate: "Working Date",
  },
  waiterPin: {
    dialogTitle: "Authorized PIN Required",
    pinLabel: "Supervisor PIN",
    verify: "Verify",
    invalidPin: "Invalid PIN. Please try again.",
    unauthorizedAction: "This waiter's linked user does not have permission to perform this action.",
    linkedUser: "Linked User",
    pinFieldLabel: "PIN",
    pinFieldHint: "4–8 digit PIN. Leave blank when editing to keep current PIN.",
    associatedUserLabel: "Associated User",
    clearPinLabel: "Clear current PIN",
    authorizedWaiter: "Authorized Waiter",
    authorizedUser: "Authorized User",
    voidAuthorizedWaiter: "Void Authorized Waiter",
    voidAuthorizedUser: "Void Authorized User",
  },
  localCommon: {
    dimensionSetup: "Dimension Setup",
    dimensionSetupSaved: "Dimension setup saved successfully!",
    dimensionSetupDeleted: "Dimension setup deleted successfully!",
    dashboardWithItem: "Dashboard {item}",
    top10ItemsSoldWithItem: "Top 10 Items Sold - {item}",
    roomRevenueBreakdown: "Room Revenue Breakdown",
    inHouseList: "In House List",
    itemLoan: "Item Loan",
    maintenanceRequestReport: "Maintenance Request Report",
    openDay: "Open Day",
    closeDay: "Close Day",
    hostURLIPAddress: "Host URL / IP Address",
    to: "To",
    unknown: "Unknown",
    customDate: "Custom Date",
    printCancellationDocument: "Print Cancellation Document",
    allowOverLimit: "Allow Over Limit",
    allowOverLimitDesc: "If enabled, transactions can exceed the available balance.",
    allowOverLimitWarning: "Transactions that exceed the limit will still be processed and the system will show an over-limit notification.",
    collectionIdentification: "Collection Identification",
    continue: "Continue",
    creditBalanceAmount: "Credit Balance Amount",
    creditBalanceAmountDesc: "Maximum usage limit per month.",
    creditBalancePositive: "Credit Balance Amount must be greater than zero",
    critical: "Critical",
    currentBalance: "Current Balance",
    currentBalanceDesc: "Remaining limit still available in the current month (system calculated).",
    limitExhausted: "Limit Exhausted",
    monthlyCreditLimit: "Monthly Credit Limit",
    monthlyCreditLimitSubtitle: "Limit applies to the current month based on posted transactions.",
    nearLimit: "Near Limit",
    normal: "Normal",
    ok: "OK",
    overLimit: "Over Limit",
    totalUsedBalance: "Total Used Balance",
    totalUsedBalanceDesc: "Total usage in the current month (system calculated).",
    warning: "Warning",
  },
  localColumns: {
    dimensionCode: "Dimension Code",
    dimensionName: "Dimension Name",
    dimensionValueCode: "Dimension Value Code",
    dimensionValueName: "Dimension Value Name",
    expenseDimensions: "Expense Dimensions",
    costDimensions: "Cost Dimensions",
    costAccount: "Cost Account",
    topProduct: "Top Product",
    hour: "Hour",
    salesRevenue: "Sales Revenue",
    transactions: "Transactions",
    averageTransactions: "Average Transactions",
    averageSales: "Average Sales",
    quantitySold: "Quantity Sold",
    averagePrice: "Average Price",
    totalOrders: "Total Orders",
    totalSales: "Total Sales",
    averageOrderAmount: "Average Order Amount",
    topProductName: "Top Product Name",
    topProductRevenue: "Top Product Revenue",
    averageBillSize: "Average Bill Size",
    topBeverageArticle: "Top Beverage Article",
    topFoodArticle: "Top Food Article",
    currentStock: "Current Stock",
    costPerUnit: "Cost Per Unit",
    last30DaysSalesQuantity: "Last 30 Days Sales Quantity",
    daysUntilOutOfStock: "Days Until Out Of Stock",
    averageDaysPerOrder: "Average Days Per Order",
    revenuePercentage: "Revenue Percentage",
    discountDescription: "Discount Description",
    discountCount: "Discount Count",
    totalDiscountAmount: "Total Discount Amount",
    reOrderLevel: "Reorder Level",
    totalRevenueExcludingTax: "Total Revenue Excluding Tax",
    articleGroupName: "Article Group Name",
    // PMS-452: Monthly Credit Limit
    creditBalanceAmount: "Credit Balance Amount",
    totalUsedBalance: "Total Used Balance",
    currentBalance: "Current Balance",
    allowOverLimit: "Allow Over Limit",
    foodRevenue: "Food Revenue",
    beverageRevenue: "Beverage Revenue"
  },
  button: {
    add: "Add"
  },
  collectionType: {
    oneCollectionTypePerCategoryPerOutlet: "Please ensure that each outlet has at least one collection type for every collection category. For the BRACELET collection category, each outlet must have exactly one collection type",
  },
  articleGroupOutlet: {
    saveArticleGroupOutletBeforeAddingRevenueCenterMealTime: "Please save this Article Group Outlet setup before adding a Meal Time Setup Revenue Center",
    confirmRevenueCenterInternalUserChange: "This action will update the revenue center setup for the selected article group outlet. Existing transactions linked to this article group outlet will not prevent the change. Do you want to continue?",
    confirmVATPostingGroupInternalUserChange: "This action will update the VAT Posting Group for the selected article group outlet. Existing transactions linked to this article group outlet will not prevent the change. Do you want to continue?",
    exemptedVATPostingGroup: "Exempted VAT Posting Group",
  },
  tableReservation: {
    seats: "Seats",
    cantReserveForDateBeforeTodayWorkingDate: "Can't reserve for a date before today's working date.",
    tableReservedFromXtoY: "Table Reserved for {x} to {y}",
    cantEditCompleted: "Can't edit completed table reservation.",
    cantCancelCompleted: "Can't cancel completed table reservation.",
    cantDeleteCompleted: "Can't delete completed table reservation.",
    cantEditCanceled: "Can't edit canceled table reservation.",
    cantCancelCanceled: "Can't cancel canceled table reservation.",
  },
  breakfastRegistration: {
    breakfastRegistration: "Breakfast Registration",
    outletClosed: "Outlet Closed",
    noGuest: "No guest",
    allGuestRegistered: "All guests already registered for this room",
    selectedGuestAlreadyRegistered: "Selected guest already registered",
    readingCard: "Reading Card",
    guestRegistered: "Guest Registered",
    readCard: "Read Card",
    registerGuest: "Register Guest",
    undoRegisterGuest: "Undo Register Guest",
    chooseGuestToUnregister: "Please choose guest to unregister",
    cantUnregisterWhosNotRegistered: "Cannot unregister a guest who has not been registered.",
    roomNotFoundInList: "Room not found in list."
  },
  mealRegistration: {
    totalExpected: "Total Expected",
    totalActual: "Total Actual",
    totalVariance: "Total Variance",
    totalBanquetReservation: "Total Banquet Reservation",
    undoRegister: "Undo Register",
    numberOfGuest: "Number of Guest",
    expected: "Expected",
    actual: "Actual",
    cardOutsideBanquetWindow: "{status}: Guest stay ({guestCheckIn} - {guestCheckOut}) is outside banquet time ({banquetStart} - {banquetEnd}).",
  },
  reports: {
    includeComplimentary: "Include Complimentary",
    showVATBreakdown: "Show VAT Breakdown",
    showFnbRevenue: "Show F&B Revenue",
    printPdfLandscape: "Print PDF as Landscape",
    posSalesByHour: "POS Sales By Hour",
    posSalesByHourReport: "POS Sales By Hour Report",
    posSalesByCategory: "POS Sales By Category",
    posSalesByCategoryReport: "POS Sales By Category Report",
    showScPwdNames: "Show Senior Citizen/PWD Names",
    posInventoryAndStock: "POS Inventory And Stock",
    posInventoryAndStockReport: "POS Inventory And Stock Report",
    salesPerformanceAndAnalysis: "Sales Performance and Analysis",
    hospitalityAndServiceInteraction: "Hospitality And Service Interaction",
    transactionAndCashierManagement: "Transaction and Cashier Management",
    inventoryAndOperationalManagement: "Inventory And Operational Management",
    bottomSalesByArticleReport: "Bottom Sales By Article Report",
    posBottomSalesByArticle: "POS Bottom Sales By Article Report",
    reportName: "Report Name",
    showAllTime: "Show All Time",
    paymentTotal: "Payment Total",
    totalIncludingTips: "Total incl. Tips",
    zReport: "POS Z-Report",
    xReport: "POS X-Report",
    birSCDiscountReport: "BIR Senior Citizen Discount Report",
    birPWDDiscountReport: "BIR PWD Discount Report",
    cashier: "Cashier",
    posSalesByTableLabel: "POS Sales By Table Label Report",
    salesSummaryByPackageReport: "Sales Summary by Package Report",
    packageCode: "Package Code",
    packageName: "Package Name",
    packageRevenue: "Package Revenue",
    packageQuantity: "Package Quantity",
    avgPackagePrice: "Avg Package Price",
    topPackage: "Top Package",
    numberOfPackages: "# of Packages",
    averagePrice: "Average Price",
    contributionPct: "% Contribution",
    contributionPctFromTotalRevenue: "Contribution % from Total Revenue",
    packageBreakdown: "Package Breakdown",
    posProductionByWaiter: "POS Production By Waiter",
    posProductionByWaiterReport: "POS Production By Waiter Report",
    reportType: "Report Type",
    asOfDate: "As-of Date",
    customRange: "Custom Range",
    quickSelect: "Quick Select",
    waiterCode: "Waiter",
    waiters: "Waiters",
    productionBreakdownFor: "Production breakdown for {waiter} ({period})",
    unassigned: "Unassigned",
    creditMemoVoidReport: "Credit Memo / Void Report",
    documentType: "Document Type",
    documentTypeCreditMemo: "Credit Memo",
    documentTypeVoid: "Void",
    documentTypeBoth: "Both",
    type: "Type",
    originalInvoiceNo: "Original Invoice No",
    originalWorkingDate: "Original Working Date",
    voidReason: "Void Reason",
  },
  articleProductType: {
    discountRevenueCenter: "Discount Revenue Center",
    perLineDiscountsWillUseTheSelectedRevenueCenter: "Per-line discounts will use the selected revenue center.",
    toEnableThisFeatureMakeSureDiscountAndAllowanceActiveInPOSParameter: "To enable this feature, make sure Apply Discounts and Allowances are activated in the POS parameters."
  },
  guestProfile: {
    guestProfile: "Guest Profile",
    successCreate: "Guest Profile created successfully.",
    successUpdate: "Guest Profile updated successfully.",
    membership: "Membership",
    membershipNumber: "Membership Number",
    isMembership: "Is Membership",
    cityNotes: "Enter at least 3 characters to find a city.",
    membershipType: "Membership Type",
    customerPIN: "Customer PIN",
    copyGuestFromFO: "Copy Guest Profile from FO?",
    successCopy: "Guest Profile copied successfully.",
    copyGuestProfile: "Copy Guest Profile",
    editGuestProfile: "Edit Guest Profile",
    seeFOGuestList: "See FO Guest List",
    foGuestList: "FO Guest List",
    saveGuestName: "Save Guest Profile Name",
    posGuestProfile: "POS Guest Profile",
    saveGuestProfileNameConfirmation: "This will update the selected Guest Profile's name, are you sure?",
    tinNumber: "TIN Number",
    scIdNumber: "Senior Citizen ID",
    pwdIdNumber: "PWD ID",
    signatureName: "Signature Name",
  },
  contactPerson: {
    contactPerson: "Contact Person",
    successCreate: "Contact Person created successfully.",
  },
  agency: {
    successCreate: "Agency created successfully.",
    successUpdate: "Agency updated successfully.",
  },
  client: {
    successCreate: "Client created successfully.",
    successUpdate: "Client updated successfully.",
  },
  clientComposition: {
    successCreate: "Client Composition created successfully.",
    successUpdate: "Client Composition updated successfully.",
    warningChangeIsLedgerAllowed: "You need permission to change \"Is Ledger Allowed\"",
    noLimit: "No Limit",
    setLimit: "Set Limit",
    currentAging: "Current Aging Balance",
    todayLedger: "Today's Ledger",
    totalUsedBalance: "Total Used Balance",
    availableCredit: "Available Credit",
  },
  payment: {
    paymentTab: "Payment",
    tipTab: "Tip",
    tips: "Tips",
    tipType: "Type",
    tipDescription: "Description",
    tipAmount: "Tip Amount",
    totalTip: "Total Tip",
    noTips: "-- No tips --",
    addTip: "Add Tip",
    tipAmountMustBePositive: "Tip amount must be greater than zero",
    cardNumber: "Card Number",
    cardName: "Card Name",
    cardExpirationDate: "Card Expiration Date",
    cardTraceNumber: "Transaction Trace Number",
    cardExpired: "Card expired",
    invoiceAmountRemaining: "Invoice Amount Remaining",
    userPayment: "User Payment",
    amountToPay: "Amount to Pay",
    change: "Change",
    remainingPayment: "Remaining Payment",
    titleHere: "Title Here",
    amountToPayGreaterThanUserPayment: "Amount to Pay can't be greater than User Payment",
    amountToPayGreaterThanRemainingPayment: "Amount to Pay can't be greater than Remaining Payment",
    cantCombinePayment: "You can't combine {payment} with another payment type",
    totalPaymentEqualInvoiceAmount: "Total payment already equal to invoice amount. Remove payments to choose other payment method.",
    paymentIsNotReady: "Payment feature is not ready!",
    notAllowedToLedger: "{payment} is not Allowed to Ledger",
    disabled: "{payment} disabled",
    ledger: "Ledger",
    insufficientCredit: "Insufficient Credit for Payment",
    differentClientPostingGroup: "Different Client Posting Group with Client",
    ledgerForm: "Ledger Form",
    manualOrNumber: "Manual OR Number",
    manualOrNumberRequired: "Manual OR number is required for cash or credit payments.",
    failedToSaveManualOrNumber: "Failed to save Manual OR number. Please try again.",
    failedToPay: "Failed to process payment. The order was saved but the bill was not paid. Please try again.",
    availableBalance: "Available Balance",
    collectionLimitExceededMessage: "Remaining balance is insufficient. Please choose another Collection Identification or contact Finance.",
    collectionLimitExceededTitle: "Collection Identification Limit Exceeded",
    creditLimit: "Credit Limit",
    invoiceAmount: "Invoice Amount",
    overLimitAmount: "Over Limit Amount",
    overLimitProcessedMessage: "Transaction has been processed with over limit amount {amount}",
    overLimitWarningMessage: "This transaction exceeds the monthly limit configured for this Collection Identification. Continue transaction?",
    overLimitWarningTitle: "Over Limit Warning",
    usedThisMonth: "Used This Month",
  },
  screen: {
    new: "New",
    inProgress: "In Progress",
    ready: "Ready",
    done: "Done",
    table: "Table",
    orderNumber: "Order #",
    sentBy: "Sent by",
    sinceOrderWasSent: "{minute} minute since order was sent | {minute} minutes since order was sent",
    todaysFinishedOrders: "Today's Finished Orders",
    posScreenOrdersReport: "POS Screen Orders Report",
    captainOrder: "Captain Order",
    printer: "Printer",
    action: "Action",
    reprintQuestion: "Reprint?",
    reprint: "Reprint",
    lastPrinted: "Last Printed",
    batch: "Batch",
    search: "Search",
    reprintAll: "All",
    reprintYes: "Yes",
    reprintNo: "No",
    popupBlocked: "Popup was blocked. Allow popups for this site to print.",
    coReprint: "CO Reprint {count}",
    markAllReady: "Mark All Ready",
    markSelectedReady: "Mark Selected Ready ({count})",
  },
  $vuetify: {
    badge: "Badge",
    close: "Close",
    loading: "Loading...",
    dataIterator: {
      noResultsText: "No matching records found",
      loadingText: "Loading items...",
    },
    dataTable: {
      itemsPerPageText: "Rows per page:",
      ariaLabel: {
        sortDescending: "Sorted descending.",
        sortAscending: "Sorted ascending.",
        sortNone: "Not sorted.",
        activateNone: "Activate to remove sorting.",
        activateDescending: "Activate to sort descending.",
        activateAscending: "Activate to sort ascending.",
      },
      sortBy: "Sort by",
    },
    dataFooter: {
      itemsPerPageText: "Items per page:",
      itemsPerPageAll: "All",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
      pageText: "{0}-{1} of {2}",
    },
    datePicker: {
      itemsSelected: "{0} selected",
      nextMonthAriaLabel: "Next month",
      nextYearAriaLabel: "Next year",
      prevMonthAriaLabel: "Previous month",
      prevYearAriaLabel: "Previous year",
    },
    noDataText: "No data available",
    carousel: {
      prev: "Previous visual",
      next: "Next visual",
      ariaLabel: {
        delimiter: "Carousel slide {0} of {1}",
      },
    },
    calendar: {
      moreEvents: "{0} more",
    },
    fileInput: {
      counter: "{0} files",
      counterSize: "{0} files ({1} in total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Pagination Navigation",
        next: "Next page",
        previous: "Previous page",
        page: "Goto Page {0}",
        currentPage: "Current Page, Page {0}",
      },
    },
    input: {
      clear: "Clear",
      prependAction: "{0} prepended action",
      appendAction: "{0} appended action",
    },
  },
  taxIntegrationLog: {
    decodeDocumentPayloadIntoJSON: "Decode document payload into JSON"
  },
  fbMenuConfiguration: {
    title: "FB Menu Configuration",
  },
  fbMenuOrderRequest: {
    def: "Digital Menu Order Request",
    open: "Open Digital Menu Order Request",
    closed: "Closed Digital Menu Order Request",
    all: "All Digital Menu Order Requests",
    chooseTable: "Choose Table",
    orderCreatedFromRequest: "Order Created From F&B Menu Request",
    posMenuQRCode: "POS F&B Menu QR Code",
    guestQR: "Guest QR",
    guestQRHint: "Show this to your guest. Scanning lets them order from this table directly into the bill.",
    guestQRPrintPopupBlocked: "Popup was blocked. Allow popups for this site to print the QR.",
    guestQRPrintFailed: "Could not prepare the QR for printing.",
    scanMeToOrder: "SCAN ME TO ORDER",
    dynamicQRDisabled: "Dynamic QR is disabled for this hotel",
    guestRoomTable: "Guest Room Table",
    assignTable: "Assign Table",
    currentlyOccupiedByGuestName: "currently occupied by Guest Name",
    confirmOrderCancelTitle: "Cancel Order",
    confirmOrderCancelBody: "Are you sure want to cancel order?",
    confirmUndoOrderCancelTitle: "Undo Cancel Order",
    confirmUndoOrderCancelBody: "Are you sure want to undo cancel order?",
    orderHasBeenCancelled: "Order has been cancelled",
    orderHasBeenUndoCancel: "Order has been restored",
    auditLog: {
      title: "Audit Log",
      guest: "Guest",
      columns: {
        created: "When",
        type: "Action",
        createdBy: "By",
        description: "Description",
      },
      types: {
        CREATE: "Order Created",
        ASSIGN_TABLE: "Table Assigned",
        CANCEL_BY_ADMIN: "Cancelled by Admin",
        UNDO_CANCEL: "Cancellation Undone",
      },
    },
  },
  package: {
    fieldRequired: "Field is required",
    codeRequired: "Code is required",
    codeMaxLength: "Code must not be longer than 10 characters",
    showPackageOrderDetailPriceMode: "Package Order Detail Price Visibility",
    showPackageDetailOnInvoice: "Show Package Detail on Invoice",
    packageOrderDetailPriceModeFollowParameter: "Follow POS Parameter",
    packageOrderDetailPriceModeForceShow: "Override: Show",
    packageOrderDetailPriceModeForceHide: "Override: Hide",
    codeAlreadyUsed: "Code {code} is already used.",
    saveSuccess: "{title} {code} has been {action}.",
    saveFailed: "Unable to {action} {title} {code}.",
    actionSaved: "saved",
    actionUpdated: "updated",
    confirmRemoveItems: "Are you sure you want to remove the selected items?",
    deleteTitle: "Delete",
    deleteSuccess: "Item(s) has been deleted.",
    deleteFailed: "Failed to delete selected item(s).",
    addOutletSuccess: "Outlet has been added to package {code}.",
    addOutletFailed: "Unable to add outlet to package {code}.",
    addArticleSuccess: "Article has been added to package {code}.",
    addArticleFailed: "Unable to add article to package {code}.",
    itemsLabel: "Selected {count} item(s)",
    remove: "Remove",
    assignOutlet: "Assign Outlet",
    assignArticle: "Assign Article",
    saveBeforeManagingRelations: "Save the package before managing outlets or articles.",
    emptyPreviewResponse: "Package preview did not return any content.",
    noArticlesInPreview: "Package has no articles to add."
  },
  tableLabelManagement: {
    accessibility: "Accessibility",
    addLabel: "Add Label",
    allCategories: "All Categories",
    allowMultipleHint: "When checked, tables can have multiple labels from this category (e.g, 'Ocean View' + 'Pool View'). When unchecked, only one label is allowed (e.g., either 'Indoor' or 'Outdoor')",
    allowMultipleLabels: "Allow multiple labels from this category",
    allowMultipleSingleInfo: "Categories marked as 'Select One' allow only as single lable per table, while 'Multiple Allowed' categories let you assign muliple labels from that category",
    appliedLabels: "Applied Labels",
    category: "Category",
    categoryDescriptionContent: "Categories group related labels together. For example, 'Physical Location' is a category containing labels like Indoor, Outdoor, Patio, etc.",
    categoryDescriptionTitle: "What are categories?",
    categoryGroup: "Category Group",
    categoryGroupHelp: "Group similar categories together in the UI",
    categoryName: "Category Name",
    chooseAColorThatMakesThisLabelEasyToIdentify: "Choose a color that makes this label easy to identify.",
    clearLabelsFilter: "Clear labels filter",
    climateControl: "Climate Control",
    createNewCategory: "Create New Category",
    createNewCategoryDescription: "Add a custom label category for your tables",
    createNewLabel: "Create New Label",
    createNewLabelDescription: "Add a custom label to categorize your tables",
    customLabels: "Custom Labels",
    description: "Description",
    editCategory: "Edit Category",
    editLabel: "Edit Label",
    environment: "Environment",
    examples: "Examples",
    familyFeatures: "Family Features",
    filterByLabels: "Filter by Labels",
    guest: "Guest",
    importSystemLabels: "Import System Labels",
    labelColor: "Label Color",
    labelDescriptionContent: "Labels are specific attributes you can assign to tables. For example, within the 'Physical Location' category, you might have labels like 'Indoor', 'Outdoor', 'Patio', etc.",
    labelDescriptionTitle: "What are labels?",
    labelName: "Label Name",
    labels: "Labels",
    labelsAreSpecificToEachOutlet: "Labels are specific to each outlet",
    labelsInUse: "Labels in Use",
    manageLabels: "Manage Labels",
    managingLabelsFor: "Managing labels for",
    modifyCategoryDescription: "Modify the '{x}' category settings ",
    modifyLabelDescription: "Modify the '{x}' label",
    multipleAllowed: "Multiple Allowed",
    multiSelectCategories: "Multi Select Categories",
    newCategory: "New Category",
    operational: "Operational",
    ordersLast30d: "Orders (30D)",
    organizeAndCustomizeTableLabelsForYourOutlets: "Organize and customize table labels for your outlets",
    outlets: "Outlets",
    physicalLocation: "Physical Location",
    preview: "Preview",
    seating: "Seating",
    seeLess: "See less",
    selectionRules: "Selection Rules",
    selectOne: "Select One",
    service: "Service",
    singleSelectCategories: "Single Select Categories",
    smokingPolicy: "Smoking Policy",
    sortOrder: "Sort Order",
    system: "System",
    systemCategory: "System Category",
    systemCategoryMessage: "This is system category. You can modify settings like 'Allow Multiple' and 'Display Group', but the category name cannot be changed. Consider creating a custom category if you need different naming.",
    systemLabel: "System Label",
    systemLabelMessage: "This is a system label. You can modify the color and other settings, but the label name cannot be changed. Consider creating a custom label if you need different naming.",
    systemLabels: "System Labels",
    tableLabels: "Table Labels",
    tablesUsing: "Tables Using",
    thisCategoryAllowsMultipleLabelsPerTable: "This category allows multiple labels per table.",
    thisCategoryAllowsOnlyOneLabelPerTable: "This category allows only one label per table.",
    tip: "Tip",
    totalCategories: "Total Categories",
    totalLabels: "Total Labels",
    usageStatistics: "Usage Statistics",
    usedByXTables: "Used by {x} tables",
    viewType: "View Type",
    xLabels: "{x} labels",
    xMore: "+{x} more",
  },
  orderNotification: {
    newOrderTitle: "New Order",
    newOrderMessage: "New order from {guest} at {outlet} ({location}) — {count} items, qty {qty}",
    orderCanceledMessage: "Order #{orderId} from {guest} at {outlet} has been canceled",
    orderUndoCanceledMessage: "Order #{orderId} from {guest} at {outlet} cancellation has been undone",
    orderAssignedToTableMessage: "Order #{orderId} from {guest} at {outlet} has been assigned to a table",
  },
  tag: {
    title: "Tags",
    tag: "Tag",
    parent: "Parent",
    parents: "Parents",
    navigate: "Navigate",
    tagsNavigation: "Tags Navigation",
    revenueCenterNotSet: "Item does not have a revenue center",
    submenu: "Submenu",
    home: "Home",
    menuHasNotBeenSetup: "Menu has not been setup",
    removeNItems: "Remove {n} item(s)",
    nItems: "{n} items",
    seeArticleLocations: "See Article Locations",
    articleLocations: "Article Locations",
    seeArticleGroups: "See Article Groups",
    seeMenuTags: "See Menu Tags",
  },
  // PMS-824 (A) — Sales Return / Sales Refund BIR documents. A NEW top-level
  // namespace on purpose: khm / ar-ae / bg merge shared LAST
  // (`configs/locales.ts`), so keys added inside a namespace that sentec-vues
  // also defines would be replaced and render as raw keys.
  salesDocuments: {
    salesReturnTitle: "Sales Return",
    salesRefundTitle: "Sales Refund",
    reasonForRefund: "REASON FOR REFUND: {value}",
    authorizer: "AUTHORIZER: {value}",
    printSalesReturn: "Print Sales Return",
    printSalesRefund: "Print Sales Refund",
    billPrinterNotConfigured: "No bill printer is configured for this outlet.",
    printAgentNotConfigured: "No print agent is configured for this device.",
  },
  // PMS-881 — BIR E-Journal + POS Adjustment Log. A NEW top-level namespace on purpose:
  // the locale merge is a shallow top-level spread, so a key added inside a namespace the
  // shared library also defines can be silently replaced.
  eJournal: {
    typeSalesInvoice: "Sales Invoice",
    typeAcknowledgementReceipt: "Acknowledgement Receipt",
    typeVoid: "Void",
    typeCreditMemo: "Credit Memo",
    typeCancel: "Cancel",
    businessName: "Business Name",
    period: "Period",
    createdBy: "Created By",
    pdfSaved: "Saved {file} — {pages} page(s).",
    pdfUnsupportedChars: "The PDF cannot reproduce these characters: {chars}. The downloaded .txt is the authoritative copy.",
    title: "BIR E-Journal",
    dateFrom: "Date From",
    dateTo: "Date To",
    lineWidth: "Line Width",
    generate: "Generate",
    downloadTxt: "Download .txt",
    allOutlets: "All outlets",
    noPermission: "You do not have permission to view the BIR E-Journal.",
    emptyState: "No fiscal documents were issued for {outlet} between {from} and {to}.",
    progress: "Building {outlet} ({n} documents)...",
    logTitle: "POS Adjustment Log",
    logNoPermission: "You do not have permission to view the POS Adjustment Log.",
    adjustmentType: "Adjustment Type",
    allTypes: "All types",
    logDate: "Log Date",
    orNo: "OR No.",
    originalOrDate: "Original OR Date",
    transactionNo: "Transaction No.",
    cashier: "Cashier",
    approvedBy: "Approved By (operator)",
    grossAmount: "Gross Amount",
    vatAmount: "VAT Amount",
    netAmount: "Net Amount",
    paymentMethod: "Payment Method",
    reason: "Reason",
    remarks: "Remarks (derived)",
    derivedNote: "Remarks are derived from the transaction; Approved By shows the operator who performed the adjustment.",
    unresolvedDates: "{n} row(s) could not resolve the original OR date.",
    logEmptyState: "No adjustments were recorded for {outlet} between {from} and {to}.",
  },
  tableLayout: {
    allPlaced: "All tables placed",
    blockingIssues: "{n} table(s) outside the canvas",
    booked: "Booked",
    designerTitle: "Table Layout",
    floorplan: "Floorplan",
    floorplanTooLarge: "Floorplan is {size} MB; the maximum is {max} MB",
    layoutView: "Layout view",
    loadOutletsFailed: "Could not load outlets",
    loadTablesFailed: "Could not load this outlet's tables",
    nudge: "Nudge",
    nudgeDown: "Nudge down 1 px",
    nudgeLeft: "Nudge left 1 px",
    nudgeRight: "Nudge right 1 px",
    nudgeUp: "Nudge up 1 px",
    overlapWarning: "{n} overlapping pair(s)",
    pickAnOutlet: "Pick an outlet to design its layout",
    publishToPos: "Show this layout in POS",
    removeFromLayout: "Remove from layout",
    saveFailed: "{n} item(s) could not be saved",
    saveSucceeded: "Layout saved",
    selectATable: "Select a table",
    shape: "Shape",
    shapeCircle: "Circle",
    shapeEllipse: "Ellipse",
    shapeRectangle: "Rectangle",
    shapeSquare: "Square",
    shapeTriangle: "Triangle",
    unplaced: "Unplaced",
  },
  // PMS-423 — Show Credit Memo / Void only (All Orders). A NEW top-level namespace on purpose:
  // the locale merge is a shallow top-level spread, so keys added inside a namespace the
  // shared library also defines can be silently replaced.
  localVoidDocumentFilter: {
    showCreditMemoVoidOnly: "Show Credit Memo / Void only",
    chooseMode: "Choose which void / credit memo orders to show",
    reversalDocuments: "Reversal documents",
    originalOrders: "Original orders",
    both: "Both",
    columnHeader: "Void / Credit Memo Role",
    roleReversal: "Reversal document",
    roleOriginal: "Original order",
  },
};
